import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import InfoIcon from "@mui/icons-material/Info";
import { Stack, Tooltip, Typography } from "@mui/material";
import { isUserVerified } from "Components/Users/utils";
import type { UserDto } from "Infrastructure/Api/Api";
import { useResource } from "Translations/Resources";
import { Resources } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Pages.Content.Users.VerificationCell;

type VerificationCellProps = {
  user: UserDto;
};

export const VerificationCell = ({
  user,
  user: {
    verificationAdditionalInfoStatus,
    verificationIdentityVerificationStatus,
    verificationRiskProfile,
    verificationBankVerificationStatus,
  },
}: VerificationCellProps) => {
  const { t } = useResource();

  return (
    <Tooltip
      title={
        <Stack spacing={0.5}>
          <Parameter
            title={t(COMPONENT_RESOURCES.AdditionalInfo)}
            value={t(
              Resources.Form.AdditionalInfo[verificationAdditionalInfoStatus],
            )}
          />
          <Parameter
            title={t(COMPONENT_RESOURCES.IdentityVerification)}
            value={t(
              Resources.Form.IdentityVerification[
                verificationIdentityVerificationStatus
              ],
            )}
          />
          <Parameter
            title={t(COMPONENT_RESOURCES.RiskProfile)}
            value={t(
              Resources.Common.RiskProfileStatus[verificationRiskProfile],
            )}
          />
          <Parameter
            title={t(COMPONENT_RESOURCES.BankVerification)}
            value={t(
              Resources.Form.BankVerification[
                verificationBankVerificationStatus
              ],
            )}
          />
        </Stack>
      }
    >
      {isUserVerified(user) ? (
        <CheckCircleOutlineIcon color="secondary" />
      ) : (
        <InfoIcon color="warning" />
      )}
    </Tooltip>
  );
};

const Parameter = ({ title, value }: { title: string; value: string }) => (
  <Stack direction="row" spacing={1}>
    <Typography>{title}</Typography>
    <Typography fontWeight="bold">{value}</Typography>
  </Stack>
);
